window.axeptioSettings = {
  clientId: window.Anatec.constants.AXEPTIO_ID,
};
(function(d, s) {
  const t = d.getElementsByTagName(s)[0], e = d.createElement(s);
  e.async = true; e.src = "//static.axept.io/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");


listenAxeptioValidation();

function listenAxeptioValidation () {
  void 0 === window._axcb && (window._axcb = [])
  window._axcb.push((axeptio) => {
    axeptio.on('cookies:complete', (choices) => {
      if (choices.intercom) {
        window.Intercom("boot", {
          app_id: window.Anatec.constants.INTERCOM_ID,
        });
      } else {
        window.Intercom('shutdown');
      }
    })
  })
};
